import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <p className="font-heading text-7xl md:text-8xl font-black text-background-300 select-none pointer-events-none">
        404
      </p>
      <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        Page not found
      </h1>
      <p className="mt-2 text-base text-foreground-500 font-mono break-all">{location.pathname}</p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-line" />
        Back to home
      </Link>
    </div>
  );
}